import { createContext } from "react";
import { ValidationResult } from "sprint-common-web";

import { ContentAssociationValidation } from "../types/AssociateContentFormValidationRules";
import { ContentAssociationDetails } from "../types/ContentAssociationDetails";

export interface IAssociateContentFormContext {
    contentDetails: ContentAssociationDetails | undefined;
    validation: ContentAssociationValidation;
    isEditDisabled: boolean;
    setValidationResult: (result?: ValidationResult) => void;
}

const defaultAssociateContentFormContext: IAssociateContentFormContext = {} as IAssociateContentFormContext;

export const AssociateContentFormContext = createContext<IAssociateContentFormContext>(
    defaultAssociateContentFormContext
);
